// RequireAuth — gates the app shell. Nothing renders while the first
// /api/auth/me probe is in flight (avoids login flicker on warm sessions).
// Signed-out users are redirected to /login with a returnUrl.

import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider.jsx";

export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;
  if (!user) {
    const returnUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnUrl=${returnUrl}`} replace />;
  }
  return children;
}

/** Gates a route to staff only; clients see a friendly denial. */
export function RequireStaff({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user?.isStaff) {
    return (
      <div className="denied">
        <h2>Staff only</h2>
        <p>This area is for TMC staff. If you believe this is a mistake, contact your TMC team.</p>
      </div>
    );
  }
  return children;
}
